export default __webpack_public_path__ + "static/media/about2.af2df5de.png";